export default "__VITE_ASSET__b605b007__"